import { Comment, RawComment } from "@/types/comment";

export const mapRawToComment = (raw: RawComment): Comment => ({
  id: raw.id,
  comment: raw.comment,
  createdBy: raw.created_by,
  createdAt: new Date(raw.created_at),
  updatedAt: new Date(raw.updated_at),
});
